module.exports = __webpack_public_path__ + "img/APPR_ORANGE.cab134e8.svg";